import { WalletConnect } from './components/WalletConnect';
import { TradingInterfacePro } from './components/TradingInterfacePro';
import { InviteCodeGate } from './components/InviteCodeGate';
import { useAccess } from './contexts/AccessContext';

function App() {
  const { hasAccess, isLoading } = useAccess();

  // Show loading state while checking access
  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <svg
            className="animate-spin h-8 w-8 text-[#2962ff]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <p className="text-[#6c7884] text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Show invite code gate if user doesn't have access
  if (!hasAccess) {
    return <InviteCodeGate />;
  }

  // Show main trading interface
  return (
    <div className="h-screen flex flex-col bg-[#000000] overflow-hidden">
      {/* Header */}
      <header className="flex-shrink-0 bg-[#0a0a0a] border-b border-[#2d3748]">
        <div className="px-6 py-3">
          <div className="flex items-center justify-between max-w-[2000px] mx-auto">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-3">
                {/* Logo - Heraldic Shield */}
                <div className="relative">
                  <svg className="w-8 h-8" viewBox="0 0 32 32" fill="none">
                    {/* Shield shape */}
                    <path
                      d="M4 6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V18C28 22.4183 24.4183 28 16 28C7.58172 28 4 22.4183 4 18V6Z"
                      fill="#0e0f10"
                      stroke="#3fb68b"
                      strokeWidth="1.5"
                    />
                    {/* Inner chevron / A shape */}
                    <path
                      d="M16 8L22 20H18.5L16 15.5L13.5 20H10L16 8Z"
                      fill="#3fb68b"
                    />
                    {/* Bottom accent bar */}
                    <path
                      d="M12 22H20"
                      stroke="#3fb68b"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                {/* Brand */}
                <div className="text-[18px] font-bold text-white tracking-tight">Atlas</div>
              </div>
            </div>

            {/* Wallet Connect */}
            <WalletConnect />
          </div>
        </div>
      </header>

      {/* Main Content - fills remaining space */}
      <main className="flex-1 overflow-hidden">
        <TradingInterfacePro />
      </main>

      {/* Footer - always visible at bottom */}
      <footer className="flex-shrink-0 bg-[#0a0a0a] border-t border-[#2d3748] py-2 px-6">
        <div className="max-w-[2000px] mx-auto flex justify-center items-center gap-6 text-[11px] text-[#6c7884]">
          <a href="/terms.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
            Terms
          </a>
          <span>•</span>
          <span className="text-[#6c7884]">
            Powered by Hyperliquid
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
